<app-layout>
  <div class="row">
    <!-- <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Talepler (Durumu: {{durumText}})</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                 <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="talepAraLoading">
                                <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                              </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                         [(ngModel)]="talepAraText" placeholder="Yazın ve Enter'a basın"
                         (keyup.enter)="talepAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountTalep"
                        (change)="talepAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModelTalep" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-talep-liste *ngIf="sourceTalep" [source]="sourceTalep.results" [isSiparis]="sourceTalep.isSiparis"></app-talep-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="sourceTalep">
          <p class="m-0 text-muted"><span>{{sourceTalep.rowCount}}
            sonuçtan {{sourceTalep.firstRowOnPage}}</span>-<span>{{sourceTalep.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageTalep === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsTalep()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageTalep === sourceTalep.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResultsTalep()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div> -->

    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Onay Bekleyen Siparişler</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                 <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="siparisAraLoading2">
                                <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                              </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                         [(ngModel)]="siparisAraText2" placeholder="Yazın ve Enter'a basın"
                         (keyup.enter)="siparisAraInputChange2()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountSiparis2"
                        (change)="siparisAraInputChange2()">
                  <option *ngFor="let p of showSearchResultCountModelSiparis2" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-siparis-liste *ngIf="sourceSiparis2" [source]="sourceSiparis2.results"></app-siparis-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="sourceSiparis2">
          <p class="m-0 text-muted"><span>{{sourceSiparis2.rowCount}}
            sonuçtan {{sourceSiparis2.firstRowOnPage}}</span>-<span>{{sourceSiparis2.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageSiparis2 === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsSiparis2()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageSiparis2 === sourceSiparis2.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResultsSiparis2()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Siparişler</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                 <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="siparisAraLoading">
                                <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                              </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                         [(ngModel)]="siparisAraText" placeholder="Yazın ve Enter'a basın"
                         (keyup.enter)="siparisAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountSiparis"
                        (change)="siparisAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModelSiparis" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-siparis-liste *ngIf="sourceSiparis" [source]="sourceSiparis.results" [isSiparis]="sourceSiparis.isSiparis" (updateSiparisler)="getSiparisler()"></app-siparis-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="sourceSiparis">
          <p class="m-0 text-muted"><span>{{sourceSiparis.rowCount}}
            sonuçtan {{sourceSiparis.firstRowOnPage}}</span>-<span>{{sourceSiparis.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageSiparis === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsSiparis()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageSiparis === sourceSiparis.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResultsSiparis()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</app-layout>
